import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const TextWrapper = styled('div', shouldNotForwardProps('width'))(({ width }) => ({
    width,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'default',
}));
